import { useState } from 'react';
import { useApiErrorContext, useScrollContext } from '@/app/components/Provider';
import { reactScrollDefaultConfig, scrollToElement } from '~/utils/utils';
import { TabsFilterValue } from '../types/project/tabs';

export function useProjectTabs(
  defaultTab = TabsFilterValue.ONGOING,
  id?: number,
) {
  const { isScrollingUp, scroll } = useScrollContext();
  const { setError } = useApiErrorContext();

  const baseBadge = {
    count: 0,
    hasMore: false,
  };

  const [badge, setBadge] = useState({
    [TabsFilterValue.NEWS]: baseBadge,
    [TabsFilterValue.ONGOING]: baseBadge,
    [TabsFilterValue.STEPS]: baseBadge,
  });

  const [activeInteraction, setActiveInteraction] = useState(id);
  const [activeTabFilter, setActiveTabFilter] = useState(defaultTab);

  const handleScroll = () => {
    const offset = isScrollingUp && !!scroll ? -60 : 0;

    scrollToElement(
      'tabs',
      {
        ...reactScrollDefaultConfig,
        delay: 0,
        offset,
      },
    );
  };

  const setTab = async (
    filter: TabsFilterValue,
    interactionId?: number,
    replace = false,
    preventScroll = false,
  ) => {
    setActiveTabFilter(filter);
    setActiveInteraction(interactionId);

    if (!replace) {
      setError(null);
    }

    if (!preventScroll) {
      handleScroll();
    }
  };

  return {
    activeInteraction,
    activeTabFilter,
    badge,
    setBadge,
    setTab,
  };
}
